/**
 * V282.3: Billing Diagnostics Plugin Interface
 * 
 * Provides diagnostic information to help debug Google Play Billing issues.
 * This plugin is Android-only and returns diagnostic data for troubleshooting.
 */

import { registerPlugin } from '@capacitor/core';

export interface AndroidDiagnostics {
  /**
   * App package name (e.g., "com.blissnet.app")
   */
  packageName: string;

  /**
   * Package name of the app that installed this app
   * - "com.android.vending" = Google Play Store (REQUIRED for billing)
   * - "null" = Sideloaded or unknown installer (billing will NOT work)
   * - "com.android.packageinstaller" = Manual APK install (billing will NOT work)
   */
  installerPackage: string;

  /**
   * Whether Google Play Services is available on this device
   * - true = Play Services available (required for billing)
   * - false = Play Services unavailable (billing will NOT work)
   */
  playServicesAvailable: boolean;

  /**
   * Android API level (e.g., 33 for Android 13)
   */
  deviceApiLevel: number;
}

export interface BillingDiagnosticsPlugin {
  /**
   * Get Android diagnostic information for billing troubleshooting
   * 
   * @returns Promise resolving to diagnostic data
   * @throws Error if diagnostics cannot be retrieved
   */
  getAndroidDiagnostics(): Promise<AndroidDiagnostics>;
}

const BillingDiagnostics = registerPlugin<BillingDiagnosticsPlugin>('BillingDiagnostics', {
  web: () => ({
    // Web stub - diagnostics only available on Android
    getAndroidDiagnostics: async () => {
      throw new Error('BillingDiagnostics is only available on Android');
    },
  }),
});

export default BillingDiagnostics;

